import { SidebarContent } from './SidebarContent'
import type { CompanySidebarHeader, SidebarTabConfig } from './index'

interface CompanySidebarNewProps {
  chainProxyId: number
  header: CompanySidebarHeader
  tabs: SidebarTabConfig[]
  doorId?: number
  address?: string
  phone?: string
}

/**
 * Company page sidebar with flex-based layout.
 */
export function CompanySidebarNew(props: CompanySidebarNewProps) {
  return (
    // h-full + min-h-0 makes the sidebar fill the parent column's
    // height instead of sizing to its own content. Combined with the
    // inner `flex-1 overflow-y-auto` middle in SidebarContent, this
    // pins the footer (Edit + Created/Updated row) to the bottom of
    // the viewport and scrolls only the middle when content overflows.
    <div className="bg-white rounded-lg border border-gray-200 shadow-sm w-[360px] flex-shrink-0 flex flex-col h-full min-h-0 overflow-hidden">
      <div className="px-[20px] pt-[20px] w-[360px] flex flex-col relative flex-1 min-h-0">
        <SidebarContent {...props} />
      </div>
    </div>
  )
}
